module.exports = __webpack_public_path__ + "img/GLEXP Logo.c3dfeb40.png";